import { LimitedTypeBatch } from '../LimitedTypeBatch';
import { PrimaryButton } from '../buttons/PrimaryButton';
import { Plan, Teller, generatePriceText } from '@raysee/schema';
import { DecorationText } from '@raysee/ui';
import Link from 'next/link';

interface Item {
  plan: Plan;
  teller: Teller;
}

interface Props {
  items: Item[];
}

const PlansList = ({ items }: Props) => (
  <section>
    <ul className="rounded-sm bg-white shadow">
      {items.map((item) => (
        <li key={item.plan.id} className="grid grid-cols-8 border-b-2">
          <Link href={`/plans/${item.plan.id}/edit`} legacyBehavior>
            <a className="col-span-8 flex items-center pb-1 pt-5 sm:col-span-7 sm:py-5">
              <img src={item.plan.imageUrl} width="50" height="50" className="mx-4 rounded-2xl" />
              <div>
                <div className="sm:flex">
                  <div>
                    <p className="line-clamp-1 text-sm text-black">{item.plan.title}</p>
                  </div>
                  <div className="flex">
                    <LimitedTypeBatch plan={item.plan} />
                  </div>
                </div>
                <p className="mt-2 line-clamp-1 text-xs leading-4 text-gray-500">
                  <DecorationText text={item.plan.description} />
                </p>
                <p className="line-clamp-1 text-xs leading-4 text-gray-500">
                  {item.plan && generatePriceText(item.plan)}
                </p>
              </div>
            </a>
          </Link>
          <div className="col-span-8 flex items-end justify-end pb-1 pr-2 sm:col-span-1 sm:items-center sm:justify-center sm:p-0 sm:pr-0">
            <PrimaryButton
              title="リンク発行"
              onClick={() =>
                navigator.clipboard
                  .writeText(
                    `https://raysee.jp/tellers/${item.teller.id}/plans/${item.plan.id}?utm_medium=tellerselfpr`,
                  )
                  .then(() => window.alert('リンクをコピーしました！'))
              }
            />
          </div>
        </li>
      ))}
    </ul>
  </section>
);

export { PlansList };
